import React from "react";
import { Chip, Box, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { displayName } from "../../app/forecastSurface";
import { useIsMobile } from "../../features/pageWidth/pageWidthSlice";

interface SelectedSurfaceChipProps
{
    value: string;
    isHovered: boolean;
    isOpen: boolean;
    backgroundColor: string;
    backgroundColorHovered: string;
    setIsHovered: ( hovered: boolean ) => void;
}

const SelectedSurfaceChip: React.FC<SelectedSurfaceChipProps> = ( {
    value,
    isHovered,
    isOpen,
    backgroundColor,
    backgroundColorHovered,
    setIsHovered
} ) =>
{
    const isMobile = useIsMobile();

    return (
        <Chip
            onMouseEnter = {() => setIsHovered( true )}
            onMouseLeave = {() => setIsHovered( false )}
            sx = {{
                height: "28px",
                width: "100%",
                backgroundColor: ( isHovered || isOpen ) ? backgroundColorHovered : backgroundColor,
                color: ( isHovered || isOpen ) ? "black" : "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.4)",
                transition: "background-color 0.2s ease, color 0.2s ease",
                cursor: "pointer",
                maxWidth: isMobile ? "200px" : "325px"
            }}
            label = {
                <Box
                    sx = {{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Typography
                        sx = {{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {isMobile ? displayName( value ) : "Weather Impacts: " + displayName( value )}
                    </Typography>
                    {isOpen ? (
                        <KeyboardArrowUpIcon sx = {{ marginLeft: 1 }}/>
                    ) : (
                        <KeyboardArrowDownIcon sx = {{ marginLeft: 1 }}/>
                    )}
                </Box>
            }
        />
    );
};

export default SelectedSurfaceChip;
